import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-custom-error',
    templateUrl: './custom-error.component.html',
    styleUrls: ['./custom-error.component.scss'],
    standalone: false
})
export class CustomErrorComponent {
  @Input() errorMessage: string
}
